import React from "react";

const TARGET_DATE = new Date("2026-03-31T12:59:00");

const Time = () => {
  const [timeLeft, setTimeLeft] = React.useState({});

  React.useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const difference = TARGET_DATE - now;
      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: 'linear-gradient(135deg, #800020 50%, #D4AF37 50%)',
        fontFamily: "'Broadway', 'sans-serif'",
        color: "#000000",
        margin: 0,
        padding: 0,
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 0,
        boxSizing: "border-box",
        userSelect: "none",
      }}
    >
      <h2
        style={{
          fontSize: "2rem",
          fontWeight: 700,
          marginBottom: "2rem",
          background: "#D4AF37",
          borderRadius: "1rem",
          padding: "0.5rem 1rem",
          textAlign: "center",
          maxWidth: "90vw",
          boxSizing: "border-box",
          userSelect: "none",
        }}
      >
        Countdown to {TARGET_DATE.toLocaleString()}
      </h2>
      <div
        style={{
          fontSize: "2rem",
          fontWeight: 600,
          background: "#800020",
          padding: "1rem 1.5rem",
          borderRadius: "2rem",
          letterSpacing: "0.1em",
          textAlign: "center",
          maxWidth: "90vw",
          boxSizing: "border-box",
          wordBreak: "break-word",
          userSelect: "none",
        }}
      >
        -{timeLeft.days}D {timeLeft.hours}H {timeLeft.minutes}M {timeLeft.seconds}S-
      </div>
      <div style={{ fontSize: "5rem", marginTop: "1.5rem", textAlign: "center" }}>🌷👩🏼‍❤️‍💋‍👨🏼🌷</div>
    </div>
  );
};

export default Time;
